/**
 * Object of possible Vendor Application Statuses
 */

export type VendorType = 'Direct' | '3rd Party' | 'Hybrid';
export type VendorLabel =
  | 'Direct Factory / Manufacturer'
  | 'Importer / Wholesaler'
  | 'Agent';

const VendorTypeLabels: { [key in VendorType]: VendorLabel } = {
  Direct: 'Direct Factory / Manufacturer',
  '3rd Party': 'Importer / Wholesaler',
  Hybrid: 'Agent',
};

export default VendorTypeLabels;
